import React from "react";
import { BrowserRouter } from "react-router-dom";
import Navigation from "./navigation";
import { Provider } from "react-redux";
import { store } from "./redux";
import "./App.css";

// loading splash for authorization
// login  - formik validations and error overlay for failure
// setup redux
// leaderboard

function App() {
  return (
    <BrowserRouter>
      <Provider store={store}>
        <div className="max-h-full h-screen flex justify-center py-12 lg:px-8">
          <div className="max-w-5xl w-full space-y-12">
            <Navigation />
          </div>
        </div>
      </Provider>
    </BrowserRouter>
  );
}

export default App;
